import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { ICON } from 'resources/constants';

import {
  Wrapper,
  Image,
  LoginWrapper,
  NewUserText,
  LoginButton,
  SpacerText,
  SpacerLine,
  RegisterButton,
  EmailButton,
  Container,
} from './elements';
import { useText, useLink, useConfig } from 'common/hooks';
import AuthenticationError from '../../common/AuthenticationError';

const deps = {
  pageLoaded: state.account.pageLoaded,
  isAuthenticating: state.appContainer.auth.isAuthenticating,
  googleRegisterClicked: sequences`appContainer.auth.googleRegisterClicked`,
  facebookRegisterClicked: sequences`appContainer.auth.facebookRegisterClicked`,
};

function RegisterProviders({
  pageLoaded,
  isAuthenticating,
  googleRegisterClicked,
  facebookRegisterClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const link = useLink();
  const { staticUrl } = useConfig();

  return (
    <Container>
      <Wrapper>
        <Image
          alt={''}
          src={`${staticUrl}/images/onboarding/connect.png`}
          width={'200px'}
          height={'200px'}
        />
        <AuthenticationError />
        <RegisterButton
          id={'register-google-btn'}
          disabled={isAuthenticating || !pageLoaded}
          onClick={() => googleRegisterClicked()}
          color={'#fff'}
          icon={ICON.googlePlus}
          iconColor={'#dc4b3e'}
          textColor={'#263238'}
        >
          {t('authentication.register_with_google')}
        </RegisterButton>
        <RegisterButton
          id={'register-facebook-btn'}
          disabled={isAuthenticating || !pageLoaded}
          onClick={() => facebookRegisterClicked()}
          color={'#fff'}
          icon={ICON.facebook2}
          iconColor={'#4267B2'}
          textColor={'#263238'}
        >
          {t('authentication.register_with_facebook')}
        </RegisterButton>
        <SpacerText text={t('appContainer.ModRegister.or')} />
        <EmailButton
          id={'register-email-btn'}
          disabled={isAuthenticating || !pageLoaded}
          href={link('register/password')}
        >
          {t('authentication.use_email')}
        </EmailButton>
        <SpacerLine />
        <LoginWrapper>
          <NewUserText>{t('authentication.existing_user')}</NewUserText>
          <LoginButton href={link('login')}>
            {t('appContainer.ModLogin.login')}
          </LoginButton>
        </LoginWrapper>
      </Wrapper>
    </Container>
  );
}

export default connect(deps, RegisterProviders);
